import { ADD_AGENCY_ACCOUNT_MANAGER_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import addAgencyAccountManager from 'root/src/client/logic/brandSettings/thunks/addAgencyAccountManager'

export default {
	[ADD_AGENCY_ACCOUNT_MANAGER_FORM_MODULE_ID]: [
		{
			action: addAgencyAccountManager,
		},
	],
}
